/* eslint-disable camelcase */

import { useEffect, useState } from 'react';
import { trackError } from 'helpers/track_error';
import type { AccountantLead } from './types';

export default function useAccountantLead() {
  const [loading, setLoading] = useState(true);
  const [fromGoogleSSO, setFromGoogleSSO] = useState(false);
  const [accountantLead, setAccountantLead] = useState<AccountantLead>({});
  const [formSubmitUrl, setFormSubmitUrl] = useState('');

  useEffect(() => {
    fetch('/partners/sign_up_data')
      .then(res => res.json())
      .then(data => {
        const gssoData = data?.gsso_data;
        const formSubmitUrlData = data?.form_submit_url;

        setFormSubmitUrl(formSubmitUrlData);
        setAccountantLead({
          first_name: data?.accoutant_lead.first_name,
          last_name: data?.accoutant_lead.last_name,
          email: data?.accoutant_lead.email,
          accounting_firm_name: data?.accoutant_lead.accounting_firm_name,
        });
        if (gssoData) {
          setFromGoogleSSO(true);
        }

        setLoading(false);
      })
      .catch(() => {
        trackError({
          error: new Error('Error getting data from partners /sign_up_form_data'),
        });
      })
      .finally(() => setLoading(false));
  }, []);

  return { loading, fromGoogleSSO, accountantLead, formSubmitUrl };
}
